// RgpdPage.jsx
import React from "react";

export default function RgpdPage() {
  return (
    <main className="rgpd-page">
      <h1>Politique de confidentialité</h1>
      <section>
        <h2>1. Responsable du traitement</h2>
        <p>
          Le site est géré par [Alexandre Hontcharouk], photographe
          professionnel enregistré en France. Contact :
          {"alexandre.professionel@gmail.com"}
          <a href="alexandre.professionel@gmail.com">
            alexandre.professionel@gmail.com
          </a>
        </p>
      </section>
      <section>
        <h2>2. Données collectées</h2>
        <p>Nous collectons uniquement les données nécessaires à :</p>
        <ul>
          <li>
            Vous recontacter après une demande via le formulaire de contact
          </li>
          <li>
            Vous envoyer des informations sur nos prestations ou événements
          </li>
          <li>Donner accès à des galeries privées (si concerné)</li>
        </ul>
        <p>
          Les données sont : prénom, nom, adresse email, téléphone, et
          éventuellement des préférences liées à la séance photo.
        </p>
      </section>
      <section>
        <h2>3. Base légale</h2>
        <p>Le traitement est fondé sur :</p>
        <ul>
          <li>Votre consentement (newsletter)</li>
          <li>
            La nécessité contractuelle (prise de contact pour une prestation)
          </li>
          <li>Notre intérêt légitime à développer notre activité</li>
        </ul>
      </section>

      <section>
        <h2>4. Durée de conservation</h2>
        <p>Vos données sont conservées :</p>
        <ul>
          <li>12 mois après un simple contact sans suite</li>
          <li>3 ans après votre dernier projet ou rendez-vous</li>
        </ul>
      </section>

      <section>
        <h2>5. Partage des données</h2>
        <p>
          Aucune donnée n’est vendue ni partagée avec des tiers, sauf obligation
          légale ou demande expresse de votre part (ex : imprimeur, album
          photo).
        </p>
      </section>

      <section>
        <h2>6. Sécurité</h2>
        <p>
          Vos données sont stockées en toute sécurité, sur des serveurs protégés
          et accessibles uniquement par [Alexandre Hontcharouk]. Le site est
          protégé par un protocole HTTPS.
        </p>
      </section>

      <section>
        <h2>7. Vos droits</h2>
        <p>Conformément au RGPD, vous pouvez :</p>
        <ul>
          <li>Demander l’accès à vos données</li>
          <li>Les faire modifier ou supprimer</li>
          <li>Vous opposer à certains traitements</li>
        </ul>
        <p>
          Il suffit d’écrire à{"Alexandre Hontcharouk"}
          <a href="alexandre.professionel@gmail.com">
            alexandre.professionel@gmail.com
          </a>
          . Nous répondons dans un délai de 30 jours.
        </p>
      </section>

      <section>
        <h2>8. Cookies</h2>
        <p>
          Ce site utilise des cookies techniques et de mesure d’audience
          anonymisés (type Google Analytics). Vous pouvez les refuser en
          cliquant sur "Refuser les cookies" dans la bannière prévue à cet
          effet.
        </p>
      </section>
    </main>
  );
}
